import styles from './Accordion.module.scss'

import React, { useEffect, useState } from 'react'

import ClassNames from 'classnames'
import PropTypes from 'prop-types'

import defer from 'Utilities/defer'

import Brands from 'Constants/Brand'
import Intents from 'Constants/Intent'
import Sizes from 'Constants/Size'
import { Svgs } from 'Constants/Svg'
import Tones from 'Constants/Tone'

import useSegment from 'Hooks/useSegment'

import Svg from 'Atoms/Svg'

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  iconClosed: PropTypes.oneOf(Svgs),
  iconOpened: PropTypes.oneOf(Svgs),
  brand: PropTypes.oneOf(Brands),
  intent: PropTypes.oneOf(Intents),
  tone: PropTypes.oneOf(Tones),
  size: PropTypes.oneOf(Sizes),
  summary: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  fill: PropTypes.bool,
  className: PropTypes.string,
  defaultOpen: PropTypes.bool,
  onChange: PropTypes.func,
  shouldCenterSummary: PropTypes.bool,
  segmentAccordionName: PropTypes.string,
}

const Accordion = ({
  children,
  tone,
  intent,
  brand,
  size,
  iconClosed,
  iconOpened,
  summary,
  fill,
  className,
  defaultOpen,
  onChange,
  shouldCenterSummary,
  gaEventCategory,
  gaEventLabel,
  segmentAccordionName,
  alignIconToTop,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(!!defaultOpen)
  const { sendSegmentTrackEvent } = useSegment()

  useEffect(() => {
    setIsOpen(defaultOpen)
  }, [defaultOpen])

  const classes = ClassNames(
    styles.accordion,
    fill && styles.accordion_fill,
    className,
    iconOpened && styles.accordion_icon_wrapper,
  )

  return (
    <details className={classes} open={isOpen} {...props}>
      <summary
        onClick={(e) => {
          e.preventDefault()

          defer(() => {
            sendSegmentTrackEvent({
              event: 'Clicked',
              properties: {
                element: `${gaEventCategory} ${gaEventLabel} ${segmentAccordionName} accordian`,
              },
            })
          })

          const newIsOpen = !isOpen
          setIsOpen(newIsOpen)
          if (onChange) {
            onChange(newIsOpen)
          }
        }}
      >
        <div
          className={ClassNames(
            shouldCenterSummary ? styles.summary_wrapper_center : styles.summary_wrapper,
            `default-open-${defaultOpen}`,
          )}
        >
          <span className={styles.summaryFullWidth}>{summary}</span>
          {iconOpened || iconClosed ? (
            <Svg
              className={alignIconToTop ? styles.accordion_icon : null}
              icon={isOpen ? iconOpened : iconClosed}
              size={size}
              tone={tone}
              intent={intent}
              brand={brand}
            />
          ) : (
            false
          )}
        </div>
      </summary>
      <div>{children}</div>
    </details>
  )
}

Accordion.propTypes = propTypes

export default Accordion
